import $ from 'jquery';
import hljs from 'highlight.js';
import {is_array} from '../../../Helpers/js/simple.functions';
import LP from '../0-lp';
import UI from '../0-ui';

LP.dlgThemeColors = {
  visible: false,
  callback: null,

  prepare: function (selector, callback) {
    LP.dlgThemeColors.callback = callback;

    $(selector).click(LP.dlgThemeColors.toggleDialog);

    LP.dlgThemeColors.init();
  },

  init: function () {
    var colorsDialog = $('#lp-colors-dialog');
    $('a[action="save"]', colorsDialog).click(LP.dlgThemeColors.saveDialog);
    $('a[action="cancel"]', colorsDialog).click(LP.dlgThemeColors.hideDialog);

    // New Style
    $('.lp-color-reset-button').click(function () {
      if ($(this).hasClass('disabled')) {
        return false;
      }

      var def = $('input', this).val();
      var area = $(this).siblings('.lp-colorpick-area');
      var input = $('input', area);

      if (def.substr(0, 3) !== 'url') {
        input.val(def);
        area.css('background', def);
      } else {
        input.val('');
        area.css('background', def);
      }

      $(this).addClass('disabled');
    });

    $('.lp-colorpick-area').colpick({
      submit: 0,
      onChange: function (hsb, hex, rgb, el) {
        var newColor = '#' + hex;
        var input = $('input', el);
        input.val(newColor);
        $(el).css('background', newColor);

        var resetButton = $(el).siblings('.lp-color-reset-button');
        var defaultColor = $('input', resetButton).val();
        resetButton.toggleClass('disabled', newColor.toLowerCase() === defaultColor.toLowerCase());
      },
      onBeforeShow: function () {
        var value = $('input', this).val();
        $(this).colpickSetColor(value);
      },
      onShow: function () {
        $(document).unbind('click', LP.dlgThemeColors.monitor);
      },
      onHide: function () {
        $(document).click(LP.dlgThemeColors.monitor);
      },
      onSubmit: function (hsb, hex, rgb, el) {
        $(el).colpickHide();
      },
    });

    // Old Style
    $('.lp-colorpick-input').colpick({
      onSubmit: function (hsb, hex, rgb, el) {
        $(el).val(hex);
        $(el).colpickHide();
      },
      onBeforeShow: function () {
        $(this).colpickSetColor(this.value);
      },
      onShow: function () {
        $(document).unbind('click', LP.dlgThemeColors.monitor);
      },
      onHide: function () {
        $(document).click(LP.dlgThemeColors.monitor);
      },
    });

    // colpick renders its fields without labels
    var colpickTexts = colorsDialog.data();
    var colpickFields = {hex_field: 'colpickHex', rgb_r: 'colpickRed', rgb_g: 'colpickGreen', rgb_b: 'colpickBlue', hsb_h: 'colpickHue', hsb_s: 'colpickSaturation', hsb_b: 'colpickBrightness'};
    $.each(colpickFields, function (field, textKey) {
      $('.colpick_' + field + ' input').attr('aria-label', colpickTexts[textKey]);
    });
  },

  toggleDialog: function () {
    //mm: sieht sehr seltsam aus....beide verstecken und dann gucken, welcher noch sichtbar ist...??
    LP.dlgThemeSettings.hideDialog(); // hide other
    LP.dlgCustomCSS.hideDialog();
    LP.dlgPollValidation.hideDialog();
    return $('#lp-colors-dialog').isVisible() ? LP.dlgThemeColors.hideDialog() : LP.dlgThemeColors.showDialog();
  },

  hideDialog: function () {
    $('#lp-colors-dialog').hide().closest('.dropdown').removeClass('open');

    $(document).unbind('click', LP.dlgThemeColors.monitor);
    return true;
  },

  showDialog: function () {
    $('#lp-colors-dialog').slideDown('fast').closest('.dropdown').addClass('open');
    $(document).click(LP.dlgThemeColors.monitor);
    return false;
  },

  monitor: function () {
    var colorsDialog = $('#lp-colors-dialog');
    var formClicked = UI.mouseIsOverWorkaround(colorsDialog);
    // var formClicked = colorsDialog.is(':hover');
    var formVisible = colorsDialog.isVisible();

    if (formVisible && !formClicked) {
      LP.dlgThemeColors.hideDialog();
      return false;
    }

    return true;
  },

  saveDialog: function () {
    var colorsDialog = $('#lp-colors-dialog');
    var formUrl = colorsDialog.attr('action');
    var formData = colorsDialog.serialize() + '&poll=' + $('#pollId').val();
    window.Browser.send(formUrl, formData, LP.questionairePage.replacePollHTML);

    LP.dlgThemeColors.hideDialog();
    return false;
  },
};

LP.dlgThemeSettings = {
  visible: false,
  callback: null,
  lastSelectedFont: 'Open Sans', //Open Sans as defaultFontFamily
  dropdownInput: null,
  allFonts: [],
  allFontsUpperCase: [],

  prepare: function (selector, callback) {
    var settingsDialog = $('#lp-settings-dialog');
    LP.dlgThemeSettings.applyFonts();
    LP.dlgThemeSettings.callback = callback;
    LP.dlgThemeSettings.dropdownInput = $('#font-id', settingsDialog).get(0);
    var selectedFont = LP.dlgThemeSettings.dropdownInput.value;

    if (selectedFont) {
      LP.dlgThemeSettings.lastSelectedFont = selectedFont;
    } else {
      LP.dlgThemeSettings.lastSelectedFont = 'Open Sans';
      LP.dlgThemeSettings.dropdownInput.value = LP.dlgThemeSettings.lastSelectedFont;
    }

    var dropdown = $('#font-dropdown', settingsDialog).get(0);
    var a = $('a', dropdown);

    for (var i = 0; i < a.length; i++) {
      LP.dlgThemeSettings.allFonts.push(a[i].textContent || a[i].innerText);
      LP.dlgThemeSettings.allFontsUpperCase.push((a[i].textContent || a[i].innerText).toUpperCase());
    }

    $(selector).click(LP.dlgThemeSettings.toggleDialog);
    settingsDialog.click(LP.dlgThemeSettings.closeDropdown);
    settingsDialog.submit(LP.dlgThemeSettings.saveDialog);
    $('#font-id', settingsDialog).click(LP.dlgThemeSettings.toggleDropdown);
    $('#font-id', settingsDialog).keyup(LP.dlgThemeSettings.filterFontsList);
    $('a[action="save"]', settingsDialog).click(LP.dlgThemeSettings.saveDialog);
    $('a[action="cancel"]', settingsDialog).click(LP.dlgThemeSettings.hideDialog);
    $('a[action="deleteBG"]', settingsDialog).click(LP.dlgThemeSettings.deleteBG);
    var $width = $('input[name="pollLayout[width]"]');
    UI.setupSpinbox($width, 360, 2048, $width.val(), 1, true, null, false, false, true);

    var $fontsize = $('input[name="pollLayout[fontsize]"]');
    UI.setupSpinbox($fontsize, 6, 200, $fontsize.val(), 1, true, null, false, false, true);

    var $opacity = $('input[name="pollLayout[opacity]"]');
    UI.setupSpinbox($opacity, 0, 100, $opacity.val(), 1, true, null, false, false, true);
  },

  toggleDialog: function () {
    LP.dlgThemeColors.hideDialog(); // hide other
    LP.dlgCustomCSS.hideDialog();
    LP.dlgPollValidation.hideDialog();
    return $('#lp-settings-dialog').isVisible() ? LP.dlgThemeSettings.hideDialog() : LP.dlgThemeSettings.showDialog();
  },

  hideDialog: function () {
    $('#lp-settings-dialog').hide().closest('.dropdown').removeClass('open');
    $(document).unbind('click', LP.dlgThemeSettings.monitor);
    return true;
  },

  showDialog: function () {
    $('#lp-settings-dialog').slideDown('fast').closest('.dropdown').addClass('open');
    $(document).click(LP.dlgThemeSettings.monitor);
    return false;
  },
  applyFonts: function () {
    var $fontInput = $('#font-id'),
      $fontsList = $('ul.lp-whitemenu'),
      fonts = window.fonts,
      sortedPublicFonts = fonts.publicFonts.sort((a, b) => a.localeCompare(b)),
      allFonts = [...fonts.accFonts, ...sortedPublicFonts];

    $fontsList.empty();
    allFonts.forEach((font) => {
      var $listItem = $(`<li class="font-item"><span style="font-family:${font}"><a>${font}</a></span></li>`);
      $fontsList.append($listItem);
      $listItem.on('click', function () {
        $fontInput.val(font).css('font-family', font);
      });
    });
  },
  monitor: function () {
    var settingsDialog = $('#lp-settings-dialog');
    var formClicked = UI.mouseIsOverWorkaround(settingsDialog);
    // var formClicked = settingsDialog.is(':hover');
    var formVisible = settingsDialog.isVisible();

    if (formVisible && !formClicked) {
      LP.dlgThemeSettings.hideDialog();
      return false;
    }
    return true;
  },

  checkFontInput: function () {
    var index = LP.dlgThemeSettings.allFontsUpperCase.indexOf(LP.dlgThemeSettings.dropdownInput.value.toUpperCase().trim());

    if (index > -1) {
      LP.dlgThemeSettings.dropdownInput.value = LP.dlgThemeSettings.allFonts[index];
      LP.dlgThemeSettings.lastSelectedFont = LP.dlgThemeSettings.allFonts[index];
    } else {
      LP.dlgThemeSettings.dropdownInput.value = LP.dlgThemeSettings.lastSelectedFont || '';
      LP.dlgThemeSettings.dropdownInput.focus();
    }

    LP.dlgThemeSettings.dropdownInput.style.fontFamily = LP.dlgThemeSettings.lastSelectedFont;
  },

  closeDropdown: function (e) {
    var dropdown = document.getElementById('font-dropdown');
    if (!e.target.matches('#font-id')) {
      if (dropdown.style.display == 'block') {
        dropdown.style.display = 'none';
      }
      LP.dlgThemeSettings.checkFontInput();
    }
  },

  toggleDropdown: function () {
    var dropdown = document.getElementById('font-dropdown');
    var a = dropdown.getElementsByTagName('a');
    $(dropdown).toggle();

    // resets possible filtering
    for (var i = 0; i < a.length; i++) {
      a[i].style.display = 'block';
    }
  },

  filterFontsList: function () {
    var input = document.getElementById('font-id');
    var dropdown = document.getElementById('font-dropdown');
    var a = dropdown.getElementsByTagName('a');
    var allFonts = [''];
    for (var i = 0; i < a.length; i++) {
      allFonts.push((a[i].textContent || a[i].innerText).toUpperCase());
    }

    //opens dropdown to show filtered list
    if (dropdown.style.display == 'none') {
      dropdown.style.display = 'block';
    }

    var filter = input.value.toUpperCase();
    for (let i = 0; i < a.length; i++) {
      const txtValue = a[i].textContent || a[i].innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        a[i].style.display = '';
      } else {
        a[i].style.display = 'none';
      }
    }
  },

  saveDialog: function (e) {
    LP.dlgThemeSettings.closeDropdown(e);

    var bgInput = $('#lp-poll-bg-file-input'),
      loader = $('<div>').timedLoader(1).prependTo($('lp-page-content'));
    if (bgInput.length > 0 && bgInput.val().length > 0) {
      var onSuccess = function (json) {
        loader.remove();
        window.Browser.send('backend/setPollLayout/', $('#lp-settings-dialog').serialize() + '&poll=' + $('#pollId').val(), function (json) {
          LP.questionairePage.replacePollHTML(json);
          $('[action="deleteBG"]').show();
        });
        window.Toasts.successToast(json.message);
      };

      var onError = function (json) {
        is_array(json.errors) &&
          json.errors.forEach(function (err) {
            return window.Toasts.errorToast(err);
          });
        loader.remove();
        return true;
      };

      window.Browser.upload('backend/uploadPollBG/', {poll: $('#pollId').val()}, 'lp-poll-bg-file-input')
        .then(onSuccess)
        .catch(onError);
    } else {
      window.Browser.send('backend/setPollLayout/', $('#lp-settings-dialog').serialize() + '&poll=' + $('#pollId').val(), LP.questionairePage.replacePollHTML);
    }

    LP.dlgThemeSettings.hideDialog();
    return false;
  },

  deleteBG: function () {
    if ($(this).is('[disabled]')) {
      return false;
    }

    window.Browser.send('backend/deleteBackground/', 'poll=' + $('#pollId').val(), function (json) {
      LP.questionairePage.replacePollHTML(json);
      $('[action="deleteBG"]').hide();
      $('#lp-poll-bg-file-input').val('');
      return false;
    });

    return false;
  },
};

LP.dlgCustomCSS = {
  visible: false,
  callback: null,
  timer: null,

  prepare: function (selector, callback) {
    LP.dlgCustomCSS.callback = callback;

    $(selector).click(LP.dlgCustomCSS.toggleDialog);

    var cssDialog = $('#lp-css-dialog');
    cssDialog.submit(LP.dlgCustomCSS.saveDialog);
    $('a[action="save"]', cssDialog).click(LP.dlgCustomCSS.saveDialog);
    $('a[action="cancel"]', cssDialog).click(LP.dlgCustomCSS.cancelDialog);
    $('.csseditor', cssDialog).keyup(function () {
      clearTimeout(LP.dlgCustomCSS.timer);
      LP.dlgCustomCSS.timer = setTimeout(LP.dlgCustomCSS.refreshCSS, 500);
    });
  },

  toggleDialog: function () {
    LP.dlgThemeSettings.hideDialog(); // hide other
    LP.dlgThemeColors.hideDialog(); // hide other
    LP.dlgPollValidation.hideDialog();
    return $('#lp-css-dialog').isVisible() ? LP.dlgCustomCSS.hideDialog() : LP.dlgCustomCSS.showDialog();
  },

  cancelDialog: function () {
    var cssDialog = $('#lp-css-dialog');
    var editor = $('.csseditor', cssDialog);
    if (editor.length > 0) {
      window.Browser.send('backend/getCustomCSS/', 'poll=' + $('#pollId').val(), function (json) {
        editor.html(json.css);
        LP.dlgCustomCSS.callback(json);
        LP.dlgCustomCSS.hideDialog();
      });
    } else {
      LP.dlgCustomCSS.hideDialog();
    }
  },

  hideDialog: function () {
    var cssDialog = $('#lp-css-dialog');
    cssDialog.hide().closest('.dropdown').removeClass('open');

    $(document).unbind('click', LP.dlgCustomCSS.monitor);
    $('.csseditor', cssDialog).removeAttr('contenteditable');
    return true;
  },

  showDialog: function () {
    var cssDialog = $('#lp-css-dialog');
    cssDialog.slideDown('fast').closest('.dropdown').addClass('open');
    var editor = $('.csseditor', cssDialog);
    if (editor.length > 0) {
      editor.attr('contenteditable', 'true');
      hljs.highlightElement(editor.get(0));
    }

    $(document).click(LP.dlgCustomCSS.monitor);
    return false;
  },

  monitor: function () {
    var cssDialog = $('#lp-css-dialog');
    var formClicked = UI.mouseIsOverWorkaround(cssDialog);
    // var formClicked = cssDialog.is(':hover');
    var formVisible = cssDialog.isVisible();

    if (formVisible && !formClicked) {
      LP.dlgCustomCSS.hideDialog();
      return false;
    }

    return true;
  },

  saveDialog: function (skipSave) {
    var cssDialog = $('#lp-css-dialog');
    var cssEditor = $('.csseditor', cssDialog);
    var formUrl = 'backend/setCustomCSS/';
    var formData = 'customCSS=' + encodeURIComponent(cssEditor.text()) + '&poll=' + $('#pollId').val();
    if (skipSave === true) {
      formData += '&skipSave=1';
    }

    window.Browser.send(formUrl, formData, function (json) {
      if (skipSave !== true) {
        cssEditor.html(json.css);
        hljs.highlightElement(cssEditor.get(0));
      }

      LP.dlgCustomCSS.callback(json);
    });

    if (skipSave !== true) {
      LP.dlgCustomCSS.hideDialog();
    }
    return false;
  },

  refreshCSS: function () {
    LP.dlgCustomCSS.saveDialog(true);
  },
};

LP.dlgPollValidation = {
  visible: false,
  doRefresh: false,

  prepare: function (selector) {
    $(selector).click(LP.dlgPollValidation.toggleDialog);
  },

  toggleDialog: function () {
    LP.dlgThemeSettings.hideDialog(); // hide other
    LP.dlgThemeColors.hideDialog(); // hide other
    LP.dlgCustomCSS.hideDialog();

    return $('#lp-validation-dialog').isVisible() ? LP.dlgPollValidation.hideDialog() : LP.dlgPollValidation.showDialog();
  },

  hideDialog: function () {
    LP.dlgPollValidation.doRefresh = false;
    $('#lp-validation-dialog').hide().closest('.dropdown').removeClass('open');
    $(document).unbind('click', LP.dlgPollValidation.monitor);
    return true;
  },

  showDialog: function () {
    if (LP.dlgPollValidation.doRefresh) {
      LP.questionairePage.validationReport();
      setTimeout(function () {
        $('#lp-validation-dialog').slideDown('fast').closest('.dropdown').addClass('open');
      }, 1000);
    } else {
      $('#lp-validation-dialog').slideDown('fast').closest('.dropdown').addClass('open');
    }
    $(document).click(LP.dlgPollValidation.monitor);
    return false;
  },

  monitor: function () {
    var validationDialog = $('#lp-validation-dialog');

    var formClicked = UI.mouseIsOverWorkaround(validationDialog);
    var formVisible = validationDialog.isVisible();

    if (formVisible && !formClicked) {
      LP.dlgPollValidation.hideDialog();
      return false;
    }

    return true;
  },
};
